import * as Yup from 'yup';

const agencySchema = Yup.object().shape({
  firstName: Yup.string().required('First Name is required'),
  lastName: Yup.string().required('Last Name is required'),
  moveIn: Yup.string().required('Move In date is required'),
  moveOut: Yup.string().required('Move Out date is required'),
  travelReason: Yup.string().required('Travel Reason is required'),
  working: Yup.string().required('Working information is required'),
  occupant: Yup.string().required('Occupant information is required'),
  propertyType: Yup.string().required('Property Type is required'),
  bedroom: Yup.string().required('Bedroom information is required'),
  budget: Yup.string().required('Budget information is required'),
  withPet: Yup.string()
    .oneOf(['Yes', 'No'])
    .required('Pet information is required'),
  description: Yup.string().required('Description is required'),
});

// Common reusable schema for person-like requester (Traveler, Tenant, Military)
const personSchema = Yup.object().shape({
  firstName: Yup.string().required('First Name is required'),
  lastName: Yup.string().required('Last Name is required'),
  email: Yup.string().required('Email is required'),
  phone: Yup.string().required('Phone is required'),
  moveIn: Yup.string().required('Move-in date is required'),
  // moveOut: Yup.string().required('Move-out date is required'),
  travelReason: Yup.string().required('Travel Reason is required'),
  working: Yup.string().required('Working information is required'),
  occupant: Yup.string().required('Occupant information is required'),
  propertyType: Yup.string().required('Property Type is required'),
  // bedroom: Yup.string().required('Number of Bedrooms is required'),
  budget: Yup.string().required('Budget information is required'),
  withPet: Yup.string()
    .oneOf(['Yes', 'No'])
    .required('Pet information is required'),
  description: Yup.string().required('Description is required'),
  contacted: Yup.string()
    .oneOf(['Phone', 'Email'])
    .required('Contact method is required'),
});

export const HomeRequestSchema = Yup.object({
  state: Yup.object()
    .nullable()
    .test('required', 'Please provide state name', (val: any) => !!val?.value),
  city: Yup.object()
    .nullable()
    .test('required', 'Please provide city name', (val: any) => !!val?.value),
  traveler: Yup.object().when('requester', {
    is: 'Traveler',
    then: () => personSchema,
  }),
  tenant: Yup.object().when('requester', {
    is: 'Tenant',
    then: () => personSchema,
  }),
  military: Yup.object().when('requester', {
    is: 'Military',
    then: () => personSchema,
  }),
  agencies: Yup.array().when('requester', {
    is: 'Agency',
    then: () => Yup.array().of(agencySchema),
    otherwise: () => Yup.array().nullable(),
  }),
});
